export default __webpack_public_path__ + "static/media/nobookings.a6c519ea.svg";